import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/materiales/getMaterialesActive.php';

export default function getMaterialesActive({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}